import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { MprcStringToHtml } from 'components';
import { MprcRibbonGenericCard } from "components/MprcRibbonList";
import { useTranslation } from "react-i18next";

interface IProps {
    marginWidth: number;
}

export const GeneralCardCompleted = ({ marginWidth }: IProps) => {
    const { t } = useTranslation("core");
    return <MprcRibbonGenericCard
        height={249}
        icon={faCircleCheck}
        color="success"
        message={<center><b><MprcStringToHtml text={t("Card.CompletedText")} splitChar={'\n'} /></b></center>}
        marginWidth={marginWidth}
    />;
};
